import React from 'react';
import { LandingV4 } from './pages/LandingV4';
import { LandingV6 } from './pages/LandingV6';
// Reads variant set by index.tsx before render — no re-computation here.
export function App() {
  const variant = (window as any).__abVariant as string;
  switch (variant) {
    case 'V6':
      return <LandingV6 data-id="element-0" />;
    case 'V4':
    default:
      return <LandingV4 data-id="element-1" />;
  }
}